import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Loader from '../../assets/loader.svg'

const Container = styled.div`
  background: ${({ theme }) => theme.themeColorPaleOpacity};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
`

const StyledLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ theme }) => theme.gutterLage};
  height: ${({ theme }) => theme.gutterLage};
`


const Loading = ({ type }) => (
  <Container>
    <StyledLoader />
  </Container>
)

Loading.propTypes = {
  type: PropTypes.string
}

Loading.defaultProps = {
  type: 'block'
}

export default Loading